import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { bindActionCreators } from 'redux';
import * as actions from '../../../../actions/api.reports.sts.actions';
import * as actionslocals from '../../../../actions/locals.actions';
import * as home from '../../../../actions/process.home.actions';

import Hidden from '@material-ui/core/Hidden';

import Query from './Menu';
import Menu from '../Menu';
import List from './List';
import Error from '../../../dialogs/Error';

import Loading from '../../../dialogs/loading';

// eslint-disable-next-line
import style from './_styles.css';

class Lot extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            hide: false,
            open: undefined,
            error: undefined,
        }
    }

    componentDidMount() {
        this.props.allLocalInfo();
    }

    handleScroll = (e) => {
        this.props.setProminentToolBar(e.currentTarget.scrollTop === 0);
    };

    handleBack = () => {
        if(this.props.lastLocation && this.props.lastLocation.pathname === "/user/login") {
            this.props.history.push("/");
        } else {
            this.props.history.goBack();
        }  
    };

    render() {
        const { info, result, report_sts_is_loading } = this.props;
        const { error } = this.state;
        if (
            info &&
            info.security &&
            info.security.totalPermits &&
            !(info.security.totalPermits.some((f) => f === '20' || f === '83') &&
              info.security.licencias.some((f) => f.id === 157 && f.activo ))
        ) {
            return <Error open id={'unauthorized_access'} handleClose={this.handleBack} />;
        } else if (error) {
            return <Error open message={error} handleClose={this.handleBack} />;
        } else {
            return (
                <div className={'flex_full_row heigth100 bg_ice_blue'}>
                    {report_sts_is_loading && <Loading open opacity />}
                    {!result
                        ? <React.Fragment>
                            <Hidden xsDown>
                                <div className={'flex_20 overflow_y_scroll padding_top_12 shadow_right_on_tablet bg_white'} >
                                    <Menu {...this.props} active="sts" />
                                </div>
                            </Hidden>
                            <div className={'flex_full_column bg_white'} >
                                <Query {...this.props} />
                            </div>
                        </React.Fragment>
                        : <List {...this.props} />
                    }
                </div>
            );
        }
    }
}

const mapStateToProps = (state) => {
    return {
        info: state.info,
        locals: state.localsInfo,
        locals_is_loading: state.locals_is_loading,
        report_sts: state.report_sts,
        report_sts_is_loading: state.report_sts_is_loading,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions, actionslocals, home), dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(Lot));



// WEBPACK FOOTER //
// ./src/components/complex/reports/sts/Index.js